export default __webpack_public_path__ + "static/media/home-preview-clinic.f94379ec.jpg";